import { HTTP } from './http-common'
import * as _ from 'lodash'

export default {
  endpoint: '/vehiculohistorial',

  list (params) {
    let url = `${this.endpoint}?`
    if (params) {
      for (let key in params) {
        url += key + '=' + params[key] + '&'
      }
    }
    return HTTP.get(url)
  },

  get (vehiculoHistorialId, params) {
    let url = `${this.endpoint}/${vehiculoHistorialId}?'`
    if (params) {
      for (let key in params) {
        url += key + '=' + params[key] + '&'
      }
    }
    return HTTP.get(url)
  },

  save (vehiculoHistorial) {
    return HTTP.post(this.endpoint, vehiculoHistorial)
  },

  delete (vehiculoHistorialId) {
    let url = `${this.endpoint}/${vehiculoHistorialId}`
    return HTTP.delete(url)
  }
}



// WEBPACK FOOTER //
// ./src/services/vehiculoHistorial.js